"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPhotoCarouselSlide = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PhotoCarouselSlideMixin = require("../../mixins/components/PhotoCarouselSlideMixin");
var StyledPhotoCarouselSlide = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledPhotoCarouselSlide",
  componentId: "c11n-8-107-0__sc-jwte3-0"
})(["", ""], _PhotoCarouselSlideMixin.PhotoCarouselSlideMixin);
exports.StyledPhotoCarouselSlide = StyledPhotoCarouselSlide;